import { isPhoneNumber } from '@frontend/generic-dialpad-accessories';
import { removeNonDigits } from '@frontend/phone-numbers';

export const formatUri = (numOrURI: string, domain: string) => {
  let callUri;

  if (isPhoneNumber(numOrURI)) {
    callUri = `${removeNonDigits(numOrURI)}@${domain}`;
  } else if (numOrURI.includes('@')) {
    callUri = numOrURI;
  } else {
    callUri = `${numOrURI}@${domain}`;
  }

  return callUri.replace('sip:', '');
};
